import CryptoJS from 'crypto-js';

import { isString } from '@/domain/utils/TypePredicates';

type VueData<T = unknown> = Record<string, T>;

let vueDataRepository: VueData;

const clarify = <T>(data: unknown): T => {
	if (!isString(data)) return data as T;

	const decoded = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(data));
	return JSON.parse(decoded);
};

const clarifyDecode = <T>(data: string): T => {
	if (!isString(data)) return data as unknown as T;

	const decoded = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(data));
	return JSON.parse(decodeURIComponent(decoded.replace(/\+/g, ' ')));
};

const obfuscate = (data: unknown): string =>
	CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(data)));

const bootGlobalData = (data?: VueData | undefined) => {
	vueDataRepository = data || {};
};

const getGlobal = (key: string, obfuscated = false, urlEncoded = false) => {
	const data = vueDataRepository?.[key];
	if (obfuscated && isString(data)) {
		return urlEncoded ? clarifyDecode(data) : clarify(data);
	}

	return data;
};

const getAllGlobalData = (): VueData | undefined => {
	const globalData = getGlobal('obfuscatedData');

	if (globalData != null) {
		try {
			return clarify<VueData>(globalData);
		} catch (e) {
			console.warn(e);
		}
	}

	return undefined;
};

const getGlobalData = <T>(key: string, fallback?: T) => {
	const clarified = getAllGlobalData();

	if (clarified !== undefined) {
		if (clarified[key] === undefined) {
			if (fallback !== undefined) {
				return fallback;
			}

			console.error(`No ${key} registered in VueData`);
		} else {
			return clarified[key];
		}
	}

	return fallback || [];
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const VueDataProvider = {
	bootGlobalData,
	getGlobal,
	getGlobalData,
	getAllGlobalData,
};

export { VueDataProvider, VueData, clarify, obfuscate };
